module.exports = __webpack_public_path__ + "img/factory-worker.d70fba8.jpg";